// src/i18n.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en/translation.json";
import de from "./locales/de/translation.json";
import ar from "./locales/ar/translation.json";
import { detectLanguage } from "./utils/languageUtils";

// Detect initial language (will be updated when country is available)
// Priority: localStorage > browser > English
const initialLanguage = detectLanguage();

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
    ar: { translation: ar },
    toast: {
      success: "Operation successful!",
      error: "An error occurred!",
    },
  },
  lng: initialLanguage,
  fallbackLng: "en", // fallback language
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: true,
  },
});

// Set initial direction based on language
if (initialLanguage === "ar") {
  document.documentElement.setAttribute("dir", "rtl");
} else {
  document.documentElement.setAttribute("dir", "ltr");
}

// Listen for language changes to persist and update direction
i18n.on("languageChanged", (lng: string) => {
  localStorage.setItem("language", lng);
  document.documentElement.setAttribute("dir", lng === "ar" ? "rtl" : "ltr");
});

export default i18n;
